// extracted by mini-css-extract-plugin
export default {"title":"homePage_title__FzVmN","text":"homePage_text__yH4Kf"};